import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "helpers/url_helper";
import { get, post, del, put } from "helpers/api_helper";
import { toast } from "react-toastify";
import { getValuesSocketData } from "helpers/secretManager";

export const getEnergyPackagesList = createAsyncThunk(
  "getEnergyPackagesList",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(`${URL.GET_ENERGY_PACKAGE_LIST}`, data, {
        signature,
        nonce,
      });
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      return Thunk.rejectWithValue(error);
    }
  },
);

export const addEnergyPackageApi = createAsyncThunk(
  "addEnergyPackageApi",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.ADD_ENERGY_PACKAGE, data, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      toast.success(response?.message);
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error.message || "Something went wrong!", null);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const editEnergyPackageApi = createAsyncThunk(
  "editEnergyPackageApi",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await put(URL.EDIT_ENERGY_PACKAGE + data._id, data, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      toast.success(response?.message);
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error.message, null);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const deleteEnergyPackage = createAsyncThunk(
  "deleteEnergyPackage",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await del(URL.DELETE_ENERGY_PACKAGE + data._id, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      toast.success(response?.message);
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error.message, null);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getEnergyTrxHistoryApi = createAsyncThunk(
  "getEnergyTrxHistoryApi",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(`${URL.GET_ENERGY_PURHCASE_HISTORY}`, data, {
        signature,
        nonce,
      });
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      return Thunk.rejectWithValue(error);
    }
  },
);

export const purchaseEnergyListDetailsApi = createAsyncThunk(
  "energyPurchaseHistoryDetailsApi",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await get(
        URL.GET_ENERGY_PURHCASE_HISTORY_DETAILS + "/" + data?._id,
        { signature, nonce },
      );
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      toast.error(error?.message || "Something went wrong!");
      callBack && callBack(error?.message || "Something went wrong!");

      return Thunk.rejectWithValue(error);
    }
  },
);
